import React, {useState, useEffect, useRef} from 'react';
import {Link} from 'react-router-dom';
import post from '../utils/post.js';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';
import clipboard from '../utils/clipboard.js';
import PaymentNew from '../components/PaymentNew.js';
import UserEdit from '../components/UserEdit.js';
import FormDate from '../components/FormDate.js';
import '../styles/trans.scss';

export default function Trans({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [info, setInfo] = useState('');
	const [data, setData] = useState([]);
	const [searchValue, setSearchValue] = useState('');
	const [offset, setOffset] = useState(0);
	const [loadedCnt, setLoadedCnt] = useState(0);
	const [showNew, setShowNew] = useState(false);
	const [dataUser, setDataUser] = useState({});
	const [dataNew, setDataNew] = useState([]);
	const [showEditUser, setShowEditUser] = useState(false);
	const [dataEditUser, setDataEditUser] = useState([]);
	const [dataLog, setDataLog] = useState([]);
	const [downloadFrom, setDownloadFrom] = useState('');
	const [downloadTo, setDownloadTo] = useState('');
	const [currPaymentId, setCurrPaymentId] = useState(0);

	const downloadFromRef = useRef();
	const downloadToRef = useRef();

	useEffect(() => {
		let date = new Date();
		let day = date.getDate() - 1;
		let day2 = date.getDate();
		let month = date.getMonth() + 1;
		let year = date.getFullYear();
		setDownloadFrom(day + '.' + month + '.' + year);
		setDownloadTo(day2 + '.' + month + '.' + year);

		getData('', 0);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (offset > 0) {
			getData(searchValue, offset);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [offset]);

	const loadNext = () => {
		setOffset((prevOffset) => {
			let newOffset = prevOffset + usrInfo.LIST_ROWS;
			return newOffset;
		});
	};

	const onChangeSearch = (value) => {
		setSearchValue(value);
		setOffset(0);
		getData(value, 0);
	};

	const getData = (search, offset) => {
		setLoading(true);

		post('getListTrans', {search: search, offset: offset})
			.then((res) => {
				if (offset === 0) {
					setData(res.data.data);
				} else {
					setData((prevRows) => {
						const updatedRows = [...data, ...res.data.data];
						return updatedRows;
					});
				}

				setDataLog(res.data.data_log);
				setDataUser(res.data.data_user);
				setLoadedCnt(res.data.data.length);

				setInfo(res.data.data_totals);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const isOK = (index, id) => {
		if (usrInfo.sysAdmin === 1) {
			setLoading(true);

			post('saveTransOK', {ID: id})
				.then((res) => {
					data[index].ISOK = 1;
					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	const addPayment = (item) => {
		setCurrPaymentId(item.ID);

		let newNote = item.COLUMN10;

		if (item.USRID > 0) {
			newNote = '';
		}

		setDataNew({id: item.ID, paymentDT: item.COLUMN0, amount: item.COLUMN1X, usrId: item.USRID, note: newNote});

		setShowNew(true);
	};

	const addBonus = (fromId, parentId, index) => {
		if (usrInfo.sysAdmin === 1) {
			setLoading(true);

			post('addBonus', {FROM_USRID: fromId, PARENT_USRID: parentId})
				.then((res) => {
					data[index].HIDDENBONUS = 1;
					setData((prevRows) => {
						const updatedRows = [...data];
						return updatedRows;
					});
					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	const closeNew = () => {
		setShowNew(false);
	};

	const updateRow = (row) => {
		let index = data.findIndex((item) => parseInt(item.ID) === parseInt(currPaymentId));

		if (index > -1) {
			data[index].HIDDENADD = 1;
			setData((prevRows) => {
				const updatedRows = [...data];
				return updatedRows;
			});
		}
	};

	const editUser = (item) => {
		setDataEditUser({ID: item.USRID, EMAIL: item.EMAIL, FIRSTNAME: item.FIRSTNAME, LASTNAME: item.LASTNAME, NICKNAME: item.NICKNAME, PHONE_NUMBER: item.PHONE_NUMBER, PHONE_PREFIX: item.PHONE_PREFIX, DOORKEY: item.DOORKEY, ACCOUNTNUMBER: item.ACCOUNTNUMBER, TOPAY_TOTAL: item.TOPAY_TOTAL, PAYEDTO_DT: item.PAYEDTO_DT, MESSAGE: item.MESSAGE, not_payed: item.not_payed, not_payed_add_person: item.not_payed_add_person, PARENT_PROMO_CODE: item.PARENT_PROMO_CODE, INSTRUCTOR: item.INSTRUCTOR, SYSADMIN: item.SYSADMIN, MANAGER: item.MANAGER, ENTRY_PRICE_ONE: item.ENTRY_PRICE_ONE});
		setShowEditUser(true);
	};

	const closeEditUser = () => {
		setShowEditUser(false);
	};

	const updateUserRow = (username, firstName, lastName, nickname, phone, prefix, id, message, payedtoDT, topayTotal, instructor, sysadmin, manager, entryPriceOne) => {
		data?.forEach((line, index) => {
			if (parseInt(line.USRID) === parseInt(id)) {
				data[index].FIRSTNAME = firstName;
				data[index].LASTNAME = lastName;
				data[index].NICKNAME = nickname;
				data[index].MESSAGE = message ? message.replace(/\n/g, '<br>') : '';
				data[index].TOPAY_TOTAL = topayTotal;
				data[index].PAYEDTO_DT = payedtoDT;
				data[index].EMAIL = username;
				data[index].INSTRUCTOR = instructor;
				data[index].SYSADMIN = sysadmin;
				data[index].MANAGER = manager;
				data[index].ENTRY_PRICE_ONE = entryPriceOne;

				setData([...data]);
			}
		});
	};

	const downloadDo = () => {
		if (usrInfo.sysAdmin === 1) {
			setLoading(true);

			post('downloadTrans', {TYPEID: 2, DTFROM: downloadFrom, DTTO: downloadTo})
				.then((res) => {
					getData('', 0);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	const savePermanent = (index, id, val) => {
		setLoading(true);

		post('savePermanent', {ID: id, PERNAMENTMEMBER: val})
			.then((res) => {
				data[index].PERNAMENTMEMBER = res.data;
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const renderUserName = (item) => {
		if (item.USRID <= 0) {
			return 'Nepřiřazená platba';
		}

		return `${item.LASTNAME} ${item.FIRSTNAME}${item.NICKNAME !== '' ? ` (${item.NICKNAME})` : ''}`;
	};

	const renderAmountClassName = (item) => `trans-page__amount ${item.COLUMN1X < 0 ? 'trans-page__amount--debit' : 'trans-page__amount--credit'}`;

	let list = data.map((item, index) => {
		return (
			<div className="trans-page__row" key={index}>
				<div className="trans-page__row-main">
					{parseInt(item.ISOK) === 0 && item.PARENT_USRID > 0 && item.USRID > 0 && usrInfo.sysAdmin === 1 && (parseFloat(item.COLUMN1X) >= usrInfo.ENTRY_PRICE_MONTH1_VAL) ? (
						<div className="trans-page__bonus-banner">
							<div className="trans-page__bonus-text">
								<span className="trans-page__bonus-label">Bonus pro</span>
								<span className="trans-page__bonus-name">{item.PARENT_USERNAME}</span>
							</div>

							{typeof item.HIDDENBONUS === 'undefined' ? (
								parseInt(item.PARENT_PERMANENT_VALID) === 1 ? (
									<button type="button" className="button check2 green trans-page__bonus-button" onClick={() => addBonus(item.USRID, item.PARENT_USRID, index)}>
										+{usrInfo.PROMO_BONUS}
									</button>
								) : (
									<button type="button" className="button check2 green trans-page__bonus-button trans-page__bonus-button--disabled" disabled title="Mentor nemá aktuálně platnou permici">
										+{usrInfo.PROMO_BONUS}
									</button>
								)
							) : (
								''
							)}
						</div>
					)
					: (
						<></>
					)}

					<div className="trans-page__topline">{item.CRDTS}</div>

					<div className="trans-page__content">
						<div className="trans-page__meta">
							<div className="trans-page__user">{renderUserName(item)}</div>
							<button type="button" className="trans-page__copy-link" onClick={() => clipboard(item.COLUMN2 + '/' + item.COLUMN3)}>
								{item.COLUMN2}/{item.COLUMN3}
							</button>
							{item.COLUMN10 !== '' ? <div className="trans-page__note">{item.COLUMN10}</div> : ''}
							{item.COLUMN12 !== '' ? <div className="trans-page__detail">{item.COLUMN12}</div> : ''}
							{item.COLUMN8 !== '' ? <div className="trans-page__detail">{item.COLUMN8}</div> : ''}
						</div>

						<div className="trans-page__side">
							<div className="trans-page__icon-row">
								{item.USRID > 0 ? (
									<>
										{usrInfo.sysAdmin === 1 ? (
											<Link to={`/user/${item.LASTNAME} ${item.FIRSTNAME}`} key="fl_r lnk_usr_trans" className="trans-page__icon-link">
												<img className="icon2 user" style={{height: '1.8rem'}} alt="" />
											</Link>
										) : (
											''
										)}

										<Link to={`/member/${item.LASTNAME} ${item.FIRSTNAME}`} key="lnk_member_trans" className="trans-page__icon-link">
											<img className="icon1 member active" style={{height: '1.8rem'}} alt="" />
										</Link>

										<Link to={`/eshopsysadmin/${item.LASTNAME} ${item.FIRSTNAME}`} key="lnk_eshop_trans" className="trans-page__icon-link">
											<img className="icon1 eshop active" style={{height: '1.8rem'}} alt="" />
										</Link>

										<Link to={`/payment/${item.LASTNAME} ${item.FIRSTNAME}`} key="lnk_payment_trans" className="trans-page__icon-link">
											<img className="icon2 permanent2" style={{height: '1.8rem'}} alt="" />
										</Link>
									</>
								) : (
									''
								)}
							</div>

							<div className="trans-page__action-row">						
								{parseInt(usrInfo.sysAdmin) === 1 && parseInt(item.ISOK) === 0 && typeof item.HIDDENADD === 'undefined' ? (
									<div className="trans-page__action-button-wrap" onClick={() => addPayment(item)}>
										<button type="button" className="button check red trans-page__state-button">+</button>
									</div>
								) : (
									''
								)}

								<div className={renderAmountClassName(item)}>
									<b>{item.COLUMN1}</b>
								</div>

								{parseInt(item.ISOK) === 0 ? (
									<div className="trans-page__action-button-wrap" onClick={() => (usrInfo.sysAdmin === 1 ? isOK(index, item.ID) : {})}>
										<button type="button" className="button check trans-page__state-button">&nbsp;</button>
									</div>
								) : (
									<div className="trans-page__action-button-wrap">
										<button type="button" className="button check green trans-page__state-button" style={{cursor: 'default'}}>
											&nbsp;
										</button>
									</div>
								)}
							</div>

							<div className="trans-page__admin-row">
								{usrInfo.sysAdmin === 1 && item.USRID > 0 ? (
									<>
										<button type="button" className="trans-page__edit-button" onClick={() => editUser(item)}>
											<img className="icon1 edit2" style={{height: '1.8rem'}} alt="" />
										</button>

										<img className={`icon2 permanent ${parseInt(item.PERNAMENTMEMBER) === 1 ? 'active' : ''} trans-page__toggle-icon`} onClick={() => savePermanent(index, item.USRID, item.PERNAMENTMEMBER)} alt="" />
									</>
								) : (
									''
								)}
							</div>

							<div className="trans-page__status-line">
								{usrInfo.sysAdmin === 1 ? (
									<span className="trans-page__last-reservation" dangerouslySetInnerHTML={{__html: item.LAST_RES_DT}}></span>
								) : (
									<span className="trans-page__last-reservation">&nbsp;</span>
								)}
							</div>
						</div>
					</div>

					{item.COLUMN16 !== '' ? (
						<div className="trans-page__warning">{item.COLUMN16}</div>
					) : (
						''
					)}
				</div>
			</div>
		);
	});

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search showSearch searchValue={searchValue} onChangeSearch={(e) => onChangeSearch(e)}>
					<div className="trans-page__top-summary">{info}</div>
				</Search>
				<PaymentNew showNew={showNew} closeNew={closeNew} updateRow={updateRow} dataNew={dataNew} dataUser={dataUser} />
				<UserEdit showEdit={showEditUser} closeEdit={closeEditUser} updateUserRow={updateUserRow} data={dataEditUser} usrInfo={usrInfo} />

				<div className={`page trans-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					{usrInfo.sysAdmin === 1 ? (
						<section className="trans-page__section trans-page__section--toolbar">
							<div className="trans-page__toolbar">
								<div className="trans-page__date-field">
									<FormDate label="" maxLength="10" readOnly value={downloadFrom} setValue={setDownloadFrom} ref={downloadFromRef} error="" />
								</div>
								<span className="trans-page__toolbar-separator">-</span>
								<div className="trans-page__date-field">
									<FormDate label="" maxLength="10" readOnly value={downloadTo} setValue={setDownloadTo} ref={downloadToRef} error="" />
								</div>
								<button
									type="button"
									className="button red trans-page__pill-button trans-page__download-button"
									onClick={() => {
										downloadDo();
									}}
								>
									Download
								</button>
							</div>

							<div className="trans-page__log" dangerouslySetInnerHTML={{__html: dataLog}}></div>
						</section>
					) : (
						''
					)}

					<div className="trans-page__list">
						{list.length > 0 ? list : <div className="trans-page__empty">Žádné transakce neodpovídají aktuálnímu filtru.</div>}
					</div>

					<div className="trans-page__load-more">
						{parseInt(loadedCnt) === parseInt(usrInfo.LIST_ROWS) ? (
							<button type="button" className="button small loadNext trans-page__pill-button trans-page__load-button" onClick={() => loadNext()}>
								Načíst další
							</button>
						) : (
							<span className="trans-page__load-all">Byly načteny všechny záznamy</span>
						)}
					</div>
				</div>
			</div>
		</>
	);
}
